import React, { useState } from 'react';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';
import analytics from '@nerdwallet/analytics';

import {
  CenteredContainer,
  Box,
  Title,
  Type,
  Button,
} from '@nerdwallet/currency';
import { CLIPBOARD_COPY_TEXT } from '~/client/lib/company-content-src/social-impact-email';
import styles from './socialimpact-email-page.module.less';

const copyTextToClipboard = async (text) => {
  if ('clipboard' in navigator) {
    const clip = await navigator.clipboard.writeText(text);
    return clip;
  }
  return document.execCommand('copy', true, text);
};

const SocialImpactEmailPage = () => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopyClick = () => {
    copyTextToClipboard(CLIPBOARD_COPY_TEXT)
      .then(() => {
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 5000);
        analytics.track('element_interacted', {
          entity_name: 'socialimpact_email_copy',
          interaction_id: analytics.uuid(),
          impression_id: 'socialimpact_email_copy',
          interaction_type: 'press',
          action: 'copy',
        });
      })
      .catch((err) => {
        return err;
      });
  };

  return (
    <CenteredContainer
      className={classNames([
        styles.socialImpactEmailContainer,
        classes('margin-vertical-5--wide'),
        classes('margin-vertical-3'),
      ])}
    >
      <Box className={classNames([classes('padding-horizontal-5--wide')])}>
        <Title align="center" size="x-large">
          The Financial Equality Project
        </Title>
        <Box
          className={classNames([
            classes('margin-top-4'),
            classes('text-align-center'),
          ])}
        >
          <Type align="center">
            Thanks for your interest in our cause. To take the next step, copy
            and paste the email below to send to your leadership team and let
            them know how they can help.
          </Type>
          <Box
            className={classNames([
              classes('background-neutral-lightest'),
              classes('padding-all-3'),
              classes('margin-vertical-3'),
              classes('text-align-left'),
              styles.socialImpactEmailClipboard,
            ])}
          >
            <Type bold light>
              Sample email:
            </Type>
            <Type light>{CLIPBOARD_COPY_TEXT}</Type>
          </Box>
          <Button disabled={isCopied} onClick={handleCopyClick} primary>
            {isCopied ? 'COPIED!' : 'COPY TEXT'}
          </Button>
        </Box>
      </Box>
    </CenteredContainer>
  );
};

SocialImpactEmailPage.displayName = 'Social Impact Email';

export default SocialImpactEmailPage;
